
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Project Gemini',
	'appExit': 'Gå til velkomstside',


	'widgetsListLabel': 'Widgetliste. Velg en widget og trykk på Enter for å legge til.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Oppdatert',
	'dirty': 'Ikke oppdatert',
	'conflict': 'Konflikt ved lagring av visningen',
	'error': 'Problem ved lagring av visningen',
	'failure': 'Kan ikke kontakte serveren',
	'saveFailed': 'Kan ikke lagre visningen',

	'wa_insync': 'Lagret',
	'wa_conflict': 'Konflikt ved lagring av visningen',
	'wa_error': 'Kan ikke lagre visningen',
	'wa_failure': 'Kan ikke kontakte serveren',

	// Menu Labels
	'changeDisplay': 'Endre visning',
	'changeToColumnChart': 'Bytt til kolonnediagram',
	'changeToBubbleChart': 'Bytt til boblediagram',
	'toggleMoveHandles': 'Bytt flyttehåndtak',
	'undo': 'Angre',
	'redo': 'Gjør om',
	'mode': 'Bytt modus',

	'untitled': 'Uten tittel',
	'remove': 'Fjern',
	'editTitle': 'Rediger tittelen',
	'edit': 'Rediger',
	'done': 'Ferdig',

	// Data tray
	'dataTrayHandleOpenLabel': 'Åpne dataskuff',
	'dataTrayHandleCloseLabel': 'Lukk dataskuff',

	// Dialogs
	'dlg_loading': 'Laster inn...',
	'dlg_ok': 'OK',
	'dlg_create': 'Opprett',
	'dlg_cancel': 'Avbryt',
	'dlg_close': 'Lukk',
	'dlg_update': 'Oppdater',
	'dlg_renameBoardTitle': 'Endre navnet på dette objektet',
	'dlg_renameDatasetTitle': 'Endre navnet på dette datasettet',
	'dlg_renameSceneTitle': 'Endre navnet på denne scenen',
	'dlg_NameLabel': 'Navn:',
	'dlg_NewNameLabel': 'Nytt navn:',
	'dlg_DefaultNameWithDataSet': 'Visningen %{name}',
	'dlg_ShareTitle': 'Del innhold',
	'dlg_UnshareTitle': 'Fjern innholdsdeling',
	'dlg_ShareUser': 'Bruker-ID:',
	'dlg_NewColumnLabel': 'Navn på ny beregning',

	'dlg_new': 'Ny...',
	'dlg_open': 'Åpne...',
	'dlg_makeACopy': 'Lag en kopi',
	'dlg_rename': 'Endre navn...',
	'dlg_moreToCome': 'Flere handlinger kommer...',

	'dlg_use': 'Bruk',

	'dlg_RelinkDatasetTitle': 'Erstatt datasett \'%{datasetName}\' med ...',

	'open_error': 'Det oppstod et problem da visningen skulle åpnes.',

	// Delete Board
	'del_dialogTitle': 'Bekreft sletting',
	'del_itemMsg': 'Er du sikker på at du vil slette \'%{name}\'?',
	'del_itemsMsg': 'Er du sikker på at du vil slette %{count} elementer?',
	'del_deleteErr': 'Kan ikke slette \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'stigende',
	'dlg_descending': 'synkende',
	'dlg_custom': 'tilpasset',
	'dlg_none': 'ingen',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Søk',

	'searchHint': 'Søk i alle dataene dine',
	'clearSearchResult': 'Tøm søkeresultater',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Sirkel',
	'shapesHexagon': 'Sekskant',
	'shapesLine': 'Linje',
	'shapesOctagon': 'Åttekant',
	'shapesPentagon': 'Femkant',
	'shapesSquare': 'Kvadrat',
	'shapesTriangle': 'Triangel',
	'shapesDiamond': 'Rombe',
	'shapesTitle': 'Formegenskaper', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Avrundet kvadrat',
	'shapesStar': 'Stjerne',
	'shapesChevron': 'Chevron',
	'shapesBadge_ribbon': 'Merkelappbånd',
	'shapesBadge': 'Merkelapp',
	'shapesHeart': 'Hjerte',
	'shapesExclamation': 'Utropstegn',
	'shapesTrendingup': 'Trend opp',
	'shapesTrendingdown': 'Trend ned',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Mennesker',
	'shapesFemale': 'Hunkjønn',
	'shapesHappyface': 'Glad',
	'shapesMale': 'Hankjønn',
	'shapesMan': 'Mann',
	'shapesNeutralface': 'Nøytralt ansikt',
	'shapesSadface': 'Trist',
	'shapesShakehands': 'Håndtrykk',
	'shapesThumbsdown': 'Tommel ned',
	'shapesThumbsup': 'Tommel opp',
	'shapesWoman': 'Kvinne',

	// Weather and places
	'shapesPlacesWeatherCat': 'Steder og vær',
	'shapesCity': 'Sted',
	'shapesCloud': 'Sky',
	'shapesEducation': 'Utdanning',
	'shapesGovernment': 'Offentlig',
	'shapesHalfcloud': 'Halv sky',
	'shapesHouse': 'Hus',
	'shapesMoon': 'Måne',
	'shapesRain': 'Regn',
	'shapesSunny': 'Solskinn',

	//Vehicles
	'shapesVehiclesCat': 'Kjøretøy',
	'shapesAirplane': 'Fly',
	'shapesCar': 'Bil',
	'shapesShip': 'Skip',
	'shapesShoppingcart': 'Handlekurv',
	'shapesTrain': 'Tog',
	'shapesTruck': 'Lastebil',

	//Objects
	'shapesObjectsCat': 'Objekter',
	'shapesBook': 'Bok',
	'shapesBriefcase': 'Koffert',
	'shapesCalendar': 'Kalender',
	'shapesCheck': 'Sjekk',
	'shapesClock': 'Klokke',
	'shapesDesktop': 'Skrivebord',
	'shapesDocument': 'Dokument',

	'shapesFood': 'Mat',
	'shapesGear': 'Tannhjul',
	'shapesHealth': 'Helse',

	'shapesIdea': 'Idé',
	'shapesMobile': 'Mobil',
	'shapesMoney_bill': 'Pengeseddel',
	'shapesMoney_coin': 'Mynt',
	'shapesPiggybank': 'Sparebøsse',
	'shapesStackofpaper': 'Papirstabel',
	'shapesStickynote1': 'Klistrelapp 1',
	'shapesStickynote2': 'Klistrelapp 2',
	'shapesTarget': 'Mål',
	'shapesTool': 'Verktøy',

	'shapesUmbrella': 'Paraply',

	'shapesBrain': 'Hjerne',
	'shapesSkull': 'Skalle',
	'shapesEye': 'Øye',

	// Arrows shapes
	'shapesArrowsCat': 'Piler',
	'shapesRightArrow': 'Pil høyre',
	'shapesLeftArrow': 'Pil venstre',
	'shapesDoubleArrow': 'Dobbeltpil',
	'shapesCurvedArrow': 'Buet pil',

	// Callouts shapes
	'shapesCalloutsCat': 'Bildeforklaringer',
	'shapesRectCallout': 'Bildeforklaring',

	// Images
	'imagesCat': 'Bilder',
	'imageWidgetTitle': 'Bildewidget',
	'imgUrl': 'Bilde-URL',
	'noImgSelected': 'Ikke noe bilde valgt',
	'enterImgUrl': 'Oppgi bilde-URL her',
	'imgPasteLink': 'Lim inn URLen og trykk på Enter for å lagre den.',
	'imgResizeToFit': 'Endre størrelse for å passe med bildets størrelse',
	'imgHeight': 'Høyde:',
	'imgWidth': 'Bredde:',
	'imgTransparency': 'Gjennomsiktighet:',
	'imgMissingUrl': 'Bilde-URLen mangler.',
	'imgUrlValidationError': 'Bilde-URLen er ikke gyldig.',
	'imgUrlInvalidDomainError': 'Bilde-URLen peker til et domene som ikke er godkjent av administratoren. Domenene som er godkjent av administratoren, er "%{domains}".',
	'notPositiveNumberError': 'Bare positive verdier',

	// line shape
	'propStrokeWidth': 'Linjetykkelse',
	'propStrokeDashArray': 'Linjestil',
	'propStrokeSolidline': 'Heltrukket linje',
	'propStrokeLineCap': 'Linjeslutt',
	'propStrokeLineCapButt': 'Butt',
	'propStrokeLineCapRound': 'Rund',
	'propStrokeLineCapSquare': 'Rett',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Spill',
	'dataPlayerValueListLabel': 'Dataspillerverdier',
	// Text Widget
	'textWidgetTitle': 'Tekstwidget',
	'textStyle': 'Stiler',
	'textStyleDescription': 'Forhåndsformaterte tekststiler',
	'textTitleStyle': 'Tittel',
	'textTitleSmallStyle': 'Tittel liten',
	'textSubtitleStyle': 'Undertittel',
	'textBodyStyle': 'Hoveddel',
	'textBodySmallStyle': 'Hovedtekst liten',
	'textCaptionStyle': 'Tittel',
	'textQuoteStyle': 'Sitat',
	'textQuoteSmallStyle': 'Sitat lite',
	'textResponsiveStyle': 'Autostørrelse',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Hårstrek',
	'textFontFamilySubClassThin': 'Tynn',
	'textFontFamilySubClassThinItalic': 'Tynn kursiv',
	'textFontFamilySubClassExtraLight': 'Ekstra lett',
	'textFontFamilySubClassExtraLightItalic': 'Ekstra lett kursiv',
	'textFontFamilySubClassLight': 'Lett',
	'textFontFamilySubClassLightItalic': 'Lett kursiv',
	'textFontFamilySubClassRegular': 'Vanlig',
	'textFontFamilySubClassRegularItalic': 'Vanlig kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Middels',
	'textFontFamilySubClassMediumItalic': 'Middels kursiv',
	'textFontFamilySubClassHeavy': 'Tung',
	'textFontFamilySubClassHeavyItalic': 'Tung kursiv',
	'textFontFamilySubClassDemiBold': 'Halvfet',
	'textFontFamilySubClassDemiBoldItalic': 'Halvfet kursiv',
	'textFontFamilySubClassBold': 'Fet',
	'textFontFamilySubClassBoldItalic': 'Fet kursiv',
	'textFontFamilySubClassExtraBold': 'Ekstra fet',
	'textFontFamilySubClassExtraBoldItalic': 'Ekstra fet kursiv',
	'textFontFamilySubClassBlack': 'Svart',
	'textFontFamilySubClassBlackItalic': 'Svart kursiv',
	'textFontFamilySubClassStencil': 'Sjablong',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Endre fontstørrelse automatisk',
	'responsiveCoachmarkContents': 'Fontstørrelsen endres automatisk for å passe når du endrer størrelsen på denne teksttypen. Du kan definere fontstørrelsen i tekstegenskapene.',

	'propText': 'Tekstdetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Tekstegenskaper', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Fontstørrelse',
	'textFontFamily': 'Fontfamilie',
	'textFontWeight': 'Skrifttykkelse', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'textFontColor': 'Farge',
	'textLineHeight': 'Linjehøyde',
	'textIndentation': 'Innrykk',
	'textIncreaseIndentation': 'Øk innrykk',
	'textDecreaseIndentation': 'Reduser innrykk',
	'textInnerMargins': 'Indre marger (px)',

	// Widget Properties
	'propImageLink': 'Bildelink',
	'propMissingURL': 'Oppgi URL',
	'propImgTop': 'Bildeegenskaper', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Generelle egenskaper', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Generelt', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Generelt', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Fyllfarge', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Tekstfarge', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Kantlinjefarge',
	'propBorderRadius': 'Hjørneradius (px)',
	'propShowBorderInPreview': 'Vis valgt kantlinje i forhåndsvisning',
	'propMaintainAxisScales': 'Vedlikehold akseskala',
	'propShowItemLabel': 'Vis elementetikett',
	'propHideLegend': 'Skjul forklaringen',
	'propColorPalette': 'Palett',
	'propLegendPosition': 'Posisjon for forklaring',
	'propHideAxisTitleLabels': 'Skjul aksetitler',
	'propLineColor': 'Linjefarge',
	'propBubbleColor': 'Boblefarge',
	'propInterpolation': 'Jevne linjer',
	'propElementColor': 'Farge på visualiseringselement',
	'propSymbolShape': 'Symbolform',
	'propHeatScalePalette': 'Fargerekkefølge',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Mørkere farger representerer mindre verdier.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Mørkere farger representerer større verdier.',
	'propImageDetails': 'Bildedetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Websidedetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Mediedetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Oppgi URLen og trykk på Enter.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Posisjon og stil',
	'propPositionLabel': 'Posisjon', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis_v1': 'X',
	'propPositionXAxis': 'X-posisjon (%{unit})',
	'propPositionYAxis_v1': 'Y',
	'propPositionYAxis': 'Y-posisjon (%{unit})',
	'propResizeLabel': 'Størrelse', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth_v1': 'Bredde',
	'propResizeWidth': 'Bredde (%{unit})',
	'propResizeHeight_v1': 'Høyde',
	'propResizeHeight': 'Høyde (%{unit})',
	'propRotateLabel_v1': 'Roter',
	'propRotateLabel': 'Roter (°)',
	'propRotateAngle': 'Vinkel', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Antall ikoner',
	'propScaleDescription': 'Velg antall ikoner',
	'propScaleFew': 'Lav',
	'propScaleDefault': 'Standard',
	'propScaleMany': 'Høy',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Denne verdien må være numerisk',

	'mediaAriaLabel': 'url-inndata',
	'dropdownAriaLabel' : 'Rullegardin',
	'ariaGroupLabel': 'Rullegardinlistekategori: %{cateoryLabel} element: %{itemLabel}. Trykk på NED-tasten for å utvide. Trykk på OPP- og NED-tastene for å navigere eller trykke på ESC for å komprimere.',
	'colorNoFillLabel': 'Uten fyll',
	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Siste oppdatering: for %{timeInterval} siden',
	'widgetTimer': 'Widgettidtaker',

	// Theme colors
	'transparent': 'Ingen farge',
	'white': 'Hvit',
	'lightGrey': 'Lys grå',
	'grey': 'Grå',
	'darkGrey': 'Mørk grå',
	'black': 'Svart',
	'lightBlue': 'Lys blå',
	'blue': 'Blå',
	'darkBlue': 'Mørk blå',
	'yellow': 'Gul',
	'orange': 'Oransje',
	'lime': 'Lime',
	'green': 'Grønn',
	'peach': 'Fersken',
	'red': 'Rød',
	'violet': 'Fiolett',
	'aqua': 'Akvamarin',
	'purple': 'Purpur',
	'plum': 'Plomme',
	'gray10': 'Grå 10',
	'gray20': 'Grå 20',
	'gray30': 'Grå 30',
	'gray50': 'Grå 50',
	'gray60': 'Grå 60',
	'gray70': 'Grå 70',
	'gray80': 'Grå 80',
	'gray90': 'Grå 90',
	'gray100': 'Grå 100',
	'blue50': 'Blå 50',
	'blue60': 'Blå 60',
	'blue70': 'Blå 70',
	'green40': 'Grønn 40',
	'green50': 'Grønn 50',
	'red50': 'Rød 50',
	'red60': 'Rød 60',


	//Theme Palette Labels
	'themeLabel': 'Tema',
	'paletteLabel': 'IBM palett %{number}',
	'heatPaletteLabel': 'IBM varmepalett %{number}',
	'conditionalPaletteLabel': 'IBM betinget palett %{number}',
	'carbonPaletteXLight': 'Carbon X lys',
	'carbonPaletteXDark': 'Carbon X mørk',
	'carbonPalettePurple': 'Purpur',
	'carbonPaletteTeal': 'Blågrønn',
	'carbonPaletteCyan': 'Cyan',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Purpur Mørk cyan',
	'carbonPaletteCyanMagenta': 'Cyan Magenta',
	'carbonPaletteGreenRed': 'Grønn Rød',
	'carbonPaletteGreenYellowRed': 'Grønn Gul Rød',
	'carbonPalettePurpleTealConvergent': 'Purpur Mørk cyan Konvergent',
	'carbonPaletteCyanMagentaConvergent': 'Cyan Magenta Konvergent',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM lys palett',
	'userPaletteColor_defaultTheme': 'IBM standardpalett',
	'userPaletteColor_darkTheme': 'IBM mørk palett',

	// Dashboard
	'propDashboardBackgroundColor': 'Bakgrunnsfarge',
	'propLayoutPositioning': 'Layoutplassering',
	'propLayoutRelative': 'Relativ',
	'propLayoutAbsolute': 'Absolutt',
	'propLayoutPositioningCoachmarkTitle': 'Velg en layoutstil',
	'propLayoutPositioningCoachmarkContent': 'I en relativ layout justeres størrelsen og plasseringen av widgeter slik at de får plass på skjermen. Widgeter i en absolutt layout vises nøyaktig slik du plasserer dem i visningen, og med den størrelsen du velger, uansett skjermstørrelse.',
	'gridText': 'Vis rutenett',
	'snapText': 'Fest til rutenett',
	'snapObjectsText': 'Fest til objekter',
	'fitPageText': 'Tilpass side',
	'gridLabel': 'Rutenett',
	'heightUnit': 'h',
	'widthUnit': 'b',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Sidestørrelse',
	'propPageSizePresetAriaLabel': 'Sidestørrelse forhåndsdefinert',
	'propPageSizePreset_v1': 'Forhåndsdefinert',
	'propPageSizePreset': 'Sidestørrelse',
	'propPageSizePresetCustom': 'Tilpasset',
	'propPageSizePreset16x9': 'Skjerm 16:9',
	'propPageSizePreset4x3': 'Skjerm 4:3',
	'propPageSizePresetInfographic': 'Infografikk',
	'propPageSizeWidth_v1': 'Bredde',
	'propPageSizeWidth': 'Bredde (px)',
	'propPageSizeHeight_v1': 'Høyde',
	'propPageSizeHeight': 'Høyde (px)',
	'propPageSizeWidthAriaLabel': 'Sidestørrelsesbredde',
	'propPageSizeHeightAriaLabel': 'Sidestørrelseshøyde',
	'propPageSizeAdjustedMessage': 'Sidestørrelsen ble økt fordi oppføringen din var under minimum eller ikke ville fått plass på dashbordet.',
	'propTabShow': 'Vis flipper',
	'propShowTabsInPreview': 'Vis faner i forhåndsvisning',
	'multilingualDashboardsLabel': 'Språk',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Standard',
	'multilingualDashboardsAddLinkText': 'Legg til et språk til',
	'multilingualDashboardsSelect': 'Velg',
	'multilingualDashboardsButtonLabel': 'Legg til',
	'multilingualDashboardTranslationMode': 'Du er nå i oversettelsesmodus (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Ferdig',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} oversettelser gjenstår',
	'multilingualDashboardRemainingString': '1 oversettelse gjenstår',
	'multilingualDashboardsSetDefault': 'Definer standardspråk',
	'multilingualDashboardIconMore': 'Flere handlinger for språket %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Oversettbart område',
	'multilingualDeleteTitle': 'Slett språk',
	'multilingualDeleteLanguageWarning': 'Er du sikker på at du vil slette språket \'%{language}\'?',
	'multilingualSelectLanguage': 'Velg et språk',
	'confirmLayoutStyleUpgradeTitle': 'Bruk på alle flipper',
	'confirmLayoutStyleUpgrade': 'Bruke denne layoutstilen på alle flipper i dashbordet?',
	'defaultBackgroundColorLabel': 'Standard',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Slett',
	'tabDeleteDialogTitle': 'Vil du slette denne flippen?',
	'tabDeleteDialogMessage': 'Alt innhold på denne flippen vil også bli slettet.',

	// Vis widget
	'propVisTypeReturn': 'Visualiseringstyper',
	'propVisDetails': 'Detaljer',

	// Alignment picker
	'propAlignPickTop': 'Toppjuster',
	'propAlignPickRight': 'Høyrejuster',
	'propAlignPickBottom': 'Bunnjuster',
	'propAlignPickLeft': 'Venstrejuster',
	'propAlignPickCenter': 'Midtstill',
	'propAlignPickMiddle': 'Midtstill vannrett',
	'propAlignPicker': 'Vannrett justering',
	'propVerticalAlignPicker': 'Loddrett justering',

	// Toolbar picker
	'propToolbarPickBold': 'Fet',
	'propToolbarPickUnderline': 'Understrek',
	'propToolbarPickItalic': 'Kursiv',
	'propToolbarPickJustifyLeft': 'Venstrejuster',
	'propToolbarPickJustifyCenter': 'Midtstill',
	'propToolbarPickJustifyRight': 'Høyrejuster',
	'propToolbarPickJustify': 'Juster',

	'propList': 'Liste',
	'propOrderedList': 'Sortert liste',
	'propUnorderedList': 'Usortert liste',

	// Symbol shapes
	'propCircle': 'Sirkel',
	'propTriangle': 'Triangel',
	'propSquare': 'Kvadrat',
	'propRect': 'Rektangel',
	'propStar': 'Stjerne',
	'propCross': 'Kryss',
	'propPlus': 'Pluss',
	'propPoly': 'Polygon',


	// True and false selection
	'propTrue': 'Sann',
	'propFalse': 'Usann',

	// Position selection
	'propLeft': 'Venstre',
	'propRight': 'Høyre',
	'propTop': 'Øverst',
	'propBottom': 'Nederst',

	// Interpolation options
	'propSmooth': 'Glatt',
	'propStraight': 'Rett',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Liste', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Flytt til venstre', // screen reader
	'srWidgetMoveUp': 'Flytt opp', // screen reader
	'srWidgetMoveRight': 'Flytt til høyre', // screen reader
	'srWidgetMoveDown': 'Flytt ned', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Øk størrelsen proporsjonalt', // screen reader
	'srWidgetResizeSmaller': 'Reduser størrelsen proporsjonalt', // screen reader
	'srWidgetResizeBiggerV': 'Øk størrelsen loddrett', // screen reader
	'srWidgetResizeSmallerV': 'Reduser størrelsen loddrett', // screen reader
	'srWidgetResizeBiggerH': 'Øk størrelsen vannrett', // screen reader
	'srWidgetResizeSmallerH': 'Reduser størrelsen vannrett', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Roter med urviseren', // screen reader
	'srWidgetRotateCCW': 'Roter mot urviseren', // screen reader

	// Recommended types
	'visChange': 'Endre visualisering',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualisering',
	'chartLabel': 'Diagrammet %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Trykk på F12 for å navigere i widgeten',
	'f10KeyDescription': 'Trykk på F10 for å starte widgetfokusvisningen',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} med verdien %{value}',

	'shapeColorLabel': 'Formfarge',
	'showLegendLabel': 'Vis forklaring',

	//Webpage
	'webpageWidgetTitle': 'Websidewidget',
	'webpagePasteLink': 'Lim inn URLen og trykk på Enter for å lagre den.',
	'propWebpageLink': 'Webside-URL',
	'propWebpageTitle': 'Websidetittel',
	'propWebpageTitleDescription': 'Tittel på webside',
	'webpageUrl': 'Webside-URL',
	'noWebpageSelected': 'Ingen webside valgt',
	'enterWebpageUrl': 'Oppgi webside-URL her',
	'propWebpageTop': 'Websideegenskaper', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'Webside-URLen mangler.',
	'webpageUrlValidationError': 'Webside-URLen er ikke gyldig.',
	'webpageHttpValidationError': 'Du må gå til websiden ved hjelp av en HTTPS-link.',
	'webpageInvalidDomainError': 'Webside-URLen peker til et domene som ikke er godkjent av administratoren. Domenene som er godkjent av administratoren, er "%{domains}".',

	//VizState
	'vzErrorLoading': 'Kan ikke laste inn visualisering',
	'vzErrorLoadingMissingData': 'Kan ikke laste inn visualisering, mangler kontekstdata',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Mediewidget',
	'mediaPasteLink': 'Lim inn URLen og trykk på Enter for å lagre den.',
	'mediaUrl': 'Medie-URL',
	'noMediaSelected': 'Ikke noe medium valgt',
	'enterMediaUrl': 'Oppgi medie-URL her',
	'videoHeight': 'Høyde:',
	'videoWidth': 'Bredde:',
	'propMediaLink': 'Medielink',
	'propMediaTitle': 'Medietittel',
	'propMediaTitleDescription': 'Tittel for media',
	'propMediaTop': 'Medieegenskaper', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'Medielink-URLen mangler.',
	'mediaUrlValidationError': 'Mediefil-URLen er ikke gyldig.',
	'mediaUnknownValidationError': 'Denne typen medium støttes ikke.',
	'mediaHttpValidationError': 'Du må gå til mediefilen ved hjelp av en HTTPS-link.',
	'mediaInvalidDomainError': 'Mediefil-URLen peker til et domene som ikke er godkjent av administratoren. Domenene som er godkjent av administratoren, er "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Egenskaper', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Datasett',
	'dataViewsLabel': 'Vis',
	'columnQuality': 'Datakvalitet',
	'columnProperties': 'Dataegenskaper',

	'dataQuality': 'Datakvalitet',
	'dataQualityRowCount': 'Antall rader',
	'dataQualityDistribution': 'Distribusjon',
	'dataRowLabel': 'Data',

	// Modelling UI
	'typeColumn': 'Type',
	'modellingColumnType': 'Type',
	'modellingColumnAggregation': 'Aggregering',
	'modellingColumnUsage': 'Bruk',
	'modellingColumnSort': 'Sorter',
	'modellingColumnFormat': 'Format',
	'modellingColumnCategory': 'Kategori',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Laster inn...',

	'modellingProcessing': 'Behandler...',
	'modellingImport': 'Importer',
	'modellingReimport': 'Importer på nytt',
	'modellingDatasourceTitle': 'Datakilde',
	'modellingImportStartedTitle': 'Import startet',
	'modellingImportStartedText': 'Importeringen av dataene kan ta litt tid.\n\n(Du kan opprette en visning mens dataene blir importert.)',
	'importDatasourceTitle': 'Tilkoblinger',
	'dropHere': 'Slipp her for å opprette en ny datakilde...',
	'browseButton': 'Bla gjennom',
	'errorNoData': 'Det er ingen data å behandle.',
	'errorNoFile': 'Det er ingen fil å laste opp.',
	'errorUploadFailed': 'Kan ikke laste opp.',
	'uploadSucceessful': 'Opplastingen var vellykket',
	'del_datasourceTitle': 'Slett datasett',
	'del_datasourceMsg': 'Er du sikker på at du vil slette \'%{name}\'?',
	'modellingFileUpdate': 'Oppdater',
	'modellingFileUpdateTitle': 'Oppdater datasett',
	'modellingFileUpdateDescription': 'Vil du oppdatere \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Oppdaterer \'%{name}\'',
	'modellingUpdateStartedTitle': 'Oppdateringsimport startet',
	'modellingUpdateStartedText': 'Oppdateringen av dataene kan ta litt tid.\n\n(Du kan opprette en visning mens dataene blir oppdatert.)',
	'modellingErrorImportUploadNoFile': 'Ingen fil å laste opp.',
	'modellingErrorImportUploadFailed': 'Kan ikke laste opp.',
	'modellingErrorImportUploadInvalidType': 'Filtypen er ikke gyldig.',
	'modellingErrorImportUploadTableFailed': 'Kan ikke hente tabeller.',
	'modellingIntentResultsTitle': 'Velg det foreslåtte datasettet som skal brukes',
	'modellingColumnViewRelationships': 'Vis beslektede tabeller',
	'modellingTableRelatedTables': 'Tabeller beslektet med \'%{name}\'',
	'modellingTable': '%{name} - Tabell',
	'modellingColumnIncludedInDataSet': 'Lagt til',
	'modellingDataSet': 'Datasett',
	'modellingViewInDataSet': 'Visning i datasett',
	'modellingViewRelatedTables': 'Visningsrelatert',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Fant ingen beslektede tabeller',

	'modellingValidatingDataset': 'Validerer...',
	'datasetFinishedRefreshing': 'Datasett %{datasetName} er oppdatert.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Behandle koblingsbane:',
	'modellingJoinColumns': 'Definer en koblingsbane for tabell: %{name}',
	'modellingJoinToTable': 'Koble til tabell: %{name}',

	// Data Quality
	'excluded': 'Ekskludert',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filter',
	'modellingColumnSortNone': 'Fjern sorteringen',
	'modellingColumnSortAsc': 'Sorter stigende',
	'modellingColumnSortDesc': 'Sorter synkende',
	'modellingColumnRemove': 'Fjern denne kolonnen',

	// Import File Browser
	'dropboxPageTitle': 'Ny Dropbox-tilkobling',
	'sizeColumn': 'Størrelse',

	//Modelling Column Property Values
	'dataType_string': 'Streng',
	'dataType_date': 'Dato',
	'dataType_integer': 'Heltall',
	'dataType_double': 'Dobbel',
	'dataType_float': 'Flytetall',
	'dataType_boolean': 'Boolsk',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Tell',
	'defaultAggregation_countdistinct': 'Tell entydige',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Gjennomsnitt',
	'defaultAggregation_sum': 'Sum',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',

	'type_fact': 'Faktum',
	'type_attribute': 'Attributt',

	'defaultSort_none': 'Ikke sorter',
	'defaultSort_asc': 'Sorter stigende',
	'defaultSort_desc': 'Sorter synkende',

	'category_none': 'Ingen',
	'category_location': 'Plassering',
	'category_monetary': 'Penger',
	'category_time': 'Tid',

	// Root menu
	'rootMenuTitle': 'Hovedmeny',

	'errorMessageTitle': 'Feil',
	'errorMessageDetails': 'Detaljer: ',
	'errorMessageTitleAssetAlreadyExists': 'Utstyr finnes allerede',

	'defaultTabTitle': 'Flipp %{index}',
	'tabAddBtnTitle': 'Legg til en ny flipp',
	'defaultInfographicTitle': 'Infografikk',

	'unsupportedConditionalFormattingEncountered': 'Betinget formatering er ikke lenger brukt på enkelte kolonner.',


	// Homepage View
	'nameColumn': 'Navn',
	'creatorColumn': 'Opprettet av',
	'creationDateColumn': 'Dato opprettet',
	'versionColumn': 'Versjon',
	'modifiedColumn': 'Sist endret',

	'filterBy': 'Filtrer elementer',
	'allFilter': 'Alle elementer',
	'createdByMeFilter': 'Opprettet av meg',
	'sharedWithMeFilter': 'Delt med meg',
	'favoritesFilter': 'Mine favoritter',
	'recentsFilter': 'Nylig lagt til',
	'sortBy': 'Sorter etter',

	// Sort Menu
	'sortModified': 'Endret',
	'sortUpdated': 'Oppdatert',
	'sortName': 'Navn',

	'viewAs': 'Vis som',
	'thumbnailsView': 'Vis som miniatyrbilder',
	'listView': 'Vis som en liste',
	'createMenu': 'Opprett',
	'newAppItem': 'Dashbord',
	'newDataSet': 'Datasett',

	'menuSelectionState_a11y': '"%{item}"-velger satt til "%{selectedItem}"',

	'unableToShareItem': 'Kan ikke dele element "%{item}".',
	'toastFetchingContent': 'Henter mer innhold...',
	'unableToGetData': 'Kan ikke hente innhold.',
	'unableToFavorite': 'Kan ikke endre Favoritt-status.',
	'hpErrorMissingRequiredOptions': 'Mangler nødvendige initialiseringsalternativer',
	'unableToOpenBoard': 'Kan ikke åpne "%{name}".',
	'unableToDuplicateBoard': 'Kan ikke duplisere "%{name}".',
	'unableToCreateBoard': 'Kan ikke opprette "%{name}".',
	'unableToCreateBoardNameConflict': 'Det finnes allerede en ressurs med samme navn.',

	// DataSet Detail View
	'status': 'Status',
	'numberOfRows': 'Rader',
	'importWarnings': 'Advarsler',
	'lineNumbers': 'Linjer',
	'excerptFromSource': 'Utdrag',
	'reason': 'Årsak',
	'numberOfRowsDropped': 'rader droppet',
	'oneRowDropped': '1 rad ble droppet',

	// Type Menu
	'typeMenuLabel': 'Type',
	'dashboardsLabel': 'Dashbord',
	'datasetsLabel': 'Datasett',
	'storiesLabel': 'Historie',
	'allLabel': 'Alle typer',

	// Board Page View App Bar
	'datasets': 'Datasett',
	'settings': 'Egenskaper',
	'add': 'Legg til',
	'widgets': 'Widgeter',
	'dashboardProperties': 'Dashbordegenskaper',
	'searchPanel' : 'Søk',
	'pins': 'Samling',
	'pinsOld': 'Mine festede ressurser',
	'pinsDateFilterHeading' : 'Dato festet',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} festet ressurs |||| %{smart_count} festede ressurser',
	'pinSearch': 'Søk',
	'pinSearchOld': 'Søk etter festede ressurser',
	'pinListView': 'Listevisning',
	'pinIconView': 'Ikonvisning',
	'pinRemove': 'Fjern',
	'pinCreate': 'Opprett',
	'pinDeleteError': 'Kan ikke slette en eller flere ressurser fra samlingen. Prøv igjen senere.',
	'pinDeleteErrorOld': 'Kan ikke slette en eller flere festede ressurser. Prøv igjen senere.',
	'pinRetrieveError': 'Kan ikke hente en eller flere festede ressurser. Prøv igjen senere.',
	'NoPinsCollected': 'Ingen festede visualiseringer',
	'pinDeletedToast': 'Festet ressurs ble fjernet',
	'pinRenamedToast': 'Navn på festet ressurs ble endret',
	'pinAddedToast': 'Festet ressurs ble lagt til i Mine festede ressurser',
	'pinningToast': 'Behandler festing...',
	'pinDateFilter': 'Datofilter',
	'pinDateFilterAll': 'Alle',
	'pinDateFilterToday': 'I dag',
	'pinDateFilterYesterday': 'I går',
	'pinDateFilterPastWeek': 'Siste uke',
	'pinDateFilterPastMonth': 'Siste måned',
	'pinDateFilterEarlier': 'Tidligere',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Rediger tittel',
	'toolbarActionSort': 'Sorter',
	'toolbarActionSortAscending': 'Sorter stigende',
	'toolbarActionSortDescending': 'Sorter synkende',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionFormat': 'Formatdata',
	'toolbarActionFormatAbbreviation': 'Forkort',
	'toolbarActionFormatNone': 'Automatisk',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Øverste eller nederste',
	'toolbarActionAddShape': 'Legg til form',
	'toolbarActionRmvShape': 'Fjern form',
	'toolbarActionToggleShapeDrop': 'Infografikkform',
	'toolbarActionToggleShapeDropTitle': 'Opprett en infografikk',
	'toolbarActionToggleShapeDropText': 'Dra en form til dette feltet for å opprette en infografikk.',
	'toolbarActionAggregationType': 'Sammenfatt',
	'toolbarDeleteActionText': 'Fjern kolonne',
	'toolbarActionFilterLocalKeepSelected': 'Behold',
	'toolbarActionFilterLocalExcludeSelected': 'Ekskluder',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Enkel beregning',
	'toolbarActionDrillBack': 'Tilbake',
	'toolbarActionDrillUp': 'Drilling oppover',
	'toolbarActionDrillDown': 'Drill nedover',
	'toolbarActionNavigate': 'Naviger',
	'toolbarActionCreateFilterGroup': 'Opprett ny tilkobling',
	'toolbarActionDisconnectFilterGroup': 'Bryt alle linker',
	'toolbarActionLinkFilterGroup': 'Legg til en eksisterende tilkobling',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Legg til',
	'sidebarMultiselect': 'Bytt mellom flere valg',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} valgt',

	'multiselectWithTotalMsg': '%{count} av %{total}',
	'sidebarGoBack': 'Gå tilbake',

	//DataSet pane
	'errorLoadingDataSets': 'Kan ikke laste inn dette datasettet',
	'errorLoadingDataSetMetaData': 'Kan ikke laste inn dette datasettet',
	'dataSetPaneLastUpdated': 'Sist oppdatert: %{date}',
	'dataSetPaneDateUnknown': 'Ukjent',
	'sourcePaneLabel': 'Valgte kilder',
	'addSourceLabel': 'Legg til en kilde',
	'find_label': 'Søk',
	'navigationPathsLabel': 'Navigeringsbaner',

	//widgetlist
	'errorLoadingWidgetList': 'Kan ikke laste inn objektene.',
	'errorLoadingThemeFile': 'Kan ikke laste inn temadefinisjonen',
	'errorLoadingLayoutFile': 'Kan ikke laste inn visningen.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Kan ikke laste inn de tilgjengelige visualiseringsdefinisjonene',

	'dwErrorLoadingVisualizationNotFound': 'Kan ikke laste inn objektet fordi det mangler en visualiseringsdefinisjon',
	'dwErrorLoadingVisualizationListNotFound': 'Kan ikke laste inn visualiseringen.',
	'dwErrorRunningQuery': 'Kan ikke hente dataene fra datasett %{datasetName}.',
	'dwErrorGeoData': 'Problemer med å vise de geografiske dataene i et kart. Velg en annen visualiseringstype. ',
	'dwPromptSignonCancelWarning': 'Dataene for denne visualiseringen er ikke tilgjengelige. Oppgi riktig legitimasjon.',
	'dwErrorMissingDataset': 'Kan ikke laste inn visualiseringen fordi det tilknyttede datasettet \'%{datasetName}\' ikke er tilgjengelig.',
	'dwErrorRenderingVisualization': 'Kan ikke laste inn denne visualiseringen.',
	'dwErrorVisualizationTooSmall': 'Visualiseringen er for liten for å vise dataene den inneholder. Gjør visualiseringen større eller begrens dataene den inneholder.',
	'aria_label_datatable': 'Datatabell',
	'aria_key_navi_datatable_desc': 'Bruk piltastene for å navigere til hver enkelt celle. Trykk på Control og Home for å gå til første rad, eller Control og End for å gå til siste rad.',
	'geomapUnrecognizedLocations': 'Ukjente steder:',
	'geomapAmbiguousLocations': 'Tvetydige regioner:',

	// custom widget
	'customWidget': 'Tilpasset widget',
	'customWidgetsTitle': 'Tilpassede widgeter',
	'noCustomWidgets': 'Ingen tilpassede widgeter',

	// Action names
	'toggleContextBar': 'Slå kontekstlinjen av/på',
	'delete': 'Slett',
	'share': 'Del',
	'unshare': 'Avslutt deling',
	'rename': 'Endre navn',
	'close': 'Lukk',
	'duplicate': 'Dupliser',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Prøv på nytt',

	'changeTemplate': 'Endre mal',

	// Aggregation Types
	'sum': 'Sum',
	'count': 'Tell',
	'countdistinct': 'Tell entydige',
	'avg': 'Gjennomsnitt',
	'min': 'Minimum',
	'max': 'Maksimum',
	'custom': 'Tilpasset',
	'calculated': 'Beregnet',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': 'Prosentvis endring',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Visualiseringkriterier...',
	'QuickAddResultsHeader': 'Datavisualiseringer',
	'NoQuickAddResults': 'Ingen treff. Vil du opprette et nytt datasett?',
	'NoQuickAddResultsRetry': 'Fant ingen treff. Prøv igjen med andre søkeord.',
	'templateWidgetTitle': 'Mal',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(tom)',

	'nullValueContent': '(ingen verdi)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Tekstfilter - %{columnName}',

	'textFilterSelectTab': 'Velg',

	'textFilterConditionTab': 'Angi en betingelse',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Ingen elementer tilgjengelig.',

	'textFilterEquals': 'Er lik',
	'textFilterContains': 'Inneholder',
	'textFilterBeginsWith': 'Begynner med',
	'textFilterEndsWith': 'Slutter med',
	'textFilterDoesNotEqual': 'Er ikke lik',
	'textFilterDoesNotContain': 'Inneholder ikke',
	'textFilterDoesNotBeginWith': 'Begynner ikke med',
	'textFilterDoesNotEndWith': 'Slutter ikke med',
	'textFilterSampleText': 'For eksempel: A',

	'textFilterAndButton': 'Og',
	'textFilterOrButton': 'Eller',

	'dateFilterMessage': 'Velg et tidsrom',
	'dateRangeControlRegionLabel': 'Tidsromfilter - %{columnName}',
	'dateFilterRangeOption': 'Områdealternativ',
	'dateFilterDateLabel': 'Dato',
	'dateFilterBlank': '(tom)',
	'dateFilterBefore': 'Før',
	'dateFilterAfter': 'Etter',
	'dateFilterBetween': 'Mellom',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': 'Dato',
	'dateIncludeBlankLabel': 'Inkluder tom dato',

	'timeTitle': 'Tid',
	'timeFilterMessage': 'Velg et tidsrom',
	'dateTimeFilterMessage': 'Velg et tidsrom med datoer og klokkeslett',

	'topbottomNumberOfResultsLabel': 'Antall resultater',
	'topbottomPercentLabel': 'Prosent',
	'topbottomNumberOfResultsLimit': 'Mellom %{lower}-%{higher}',
	'topbottomSelectOption': 'Øverste eller nederste alternativ',
	'topbottomOptionLabel': 'Vis',
	'searchByLabel': 'Etter',
	'searchNoMatches': 'Ingen samsvar funnet',
	'topbottomRankColumnLabel': 'Legg til en rangeringskolonne i tabellen',
	'topbottomNone': 'Ingen',
	'topCount': 'Øverste antall',
	'topPercent': 'Øverste %',
	'bottomCount': 'Nederste antall',
	'bottomPercent': 'Nederste %',
	'topbottomSearchColumn': 'Finn en kolonne',
	'searchColumnAriaLabel': 'Finn en kolonne. Skriv navnet på kolonnen du vil søke etter, og bruk deretter pil ned for å finne kolonnen på en liste',
	'rankColumnLabel': 'Rangering (%{columnLabel})',
	'topbottomClearLabel': 'Fjern',

	'rangeFilterControlRegionLabel': 'Områdefilter - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Glidebryterkontroll, bruk høyre- og venstrepilene til å flytte glidebryterhåndtakene',
	'sliderHandleLabel': 'Glidebryterhåndtak',
	'a11ySliderHandleLabel': 'Glidebryterhåndtak %{sliderValue}',
	'sliderInputLabel': 'verdi',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Noen av datasettelementene som er brukt i denne visualiseringen, er ikke tilgjengelige.',
	'datasetItemUnavailable': 'Dette datasettelementet er ikke tilgjengelig',

	//Authoring topBottom
	'topOperator': 'Øverst',
	'bottomOperator': 'Nederst',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} etter %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Bare dette objektet',
	'deleteTopBottom': 'Slett øverste eller nederste antall',
	'editTopBottom': 'Rediger øverste eller nederste antall',
	'deleteDrillState': 'Slett gjeldende drillestatus',
	'ariaDeleteDrillStateLabel': 'Trykk på Enter for å redigere øverste eller nederste antall.',
	'drillUpStateTitle': 'Drilling oppover',
	'drillDownStateTitle': 'Drilling nedover',
	'ariaEditTopBottomLabel': 'Trykk på Enter for å redigere øverste eller nederste antall.',
	'ariaDeleteTopBottomLabel': 'Trykk på DELETE-tasten for å slette øverste eller nederste antall.',

	// Authoring filtering
	'dimFilterIn': 'Inkluderer: %{in}',
	'dimFilterNotIn': 'Ekskluderer: %{out}',
	'measureFilterBetween': 'Mellom %{lowerBound} og %{upperBound}',
	'measureFilterNotBetween': 'Ikke mellom %{lowerBound} og %{upperBound}',
	'gtFilter': 'Etter %{lowerBound}',
	'ltFilter': 'Før %{upperBound}',
	'notGtFilter': 'Ikke etter %{lowerBound}',
	'notLtFilter': 'Ikke før %{upperBound}',
	'localFilterTitle': 'Bare dette objektet',
	'globalFilterTitle': 'Alle objekter',
	'deleteFilter': 'Slett filter',
	'editFilter': 'Rediger filter',
	'ariaEditFilterLabel': 'Trykk på Enter for å redigere filteret.',
	'ariaDeleteFilterLabel': 'Trykk på DELETE-tasten for å slette filteret.',

	// Prompts
	'ariaEditPrompt': 'Trykk på Enter for å endre forespørselsverdien',

	'moreDataIndicator': 'Dataene dine ble kuttet ved %{threshold} elementer. Bruk et filter for å vise færre.',

	// data point filtering
	'dataPointFilterTitle': 'Datapunkter',
	'dataPointFilterIncludeSummary': 'Inkludert %{valueCount} datapunkter',
	'dataPointFilterExcludeSummary': 'Ekskluderte %{valueCount} datapunkter',

	// DB2 connection page
	'db2Database': 'DB2-database (%{jdbcConnection})',
	'db2Title': 'Koble til IBM DB2',

	// Database
	'databaseConnectionMessage': 'Oppgi detaljene for databasetilkoblingen:',
	'connectionString': 'Databasetilkoblingsstreng',
	'databaseCredentials': 'Legitimasjon: ',
	'databaseUserName': 'Brukernavn',
	'databasePassword': 'Passord',
	'databaseConnect': 'Koble til',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Oppgi et søkeord:',
	'twitterKeyword': 'Nøkkelord',
	'twitterSearch': 'Søk',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Kan ikke opprette visningen: %{error}\nMislykket operasjon: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Widgetfiltre',
	'missingColumn': 'Mangler: %{columnLabel}',
	'missingFiltering': 'Mangler filtre på følgende kolonne-IDer:',
	'heatByLabel': 'Varme etter',
	'evColumns': 'Kolonner',
	'evLocalFilters': 'Lokale filtre',
	'evExpand': 'Utvid',
	'evFilterTooltip': 'Filter',
	'evAdd': 'Legg til en kolonne',

	// Navigation View
	'navigationBack': 'Tilbake',

	// Pinning
	'contentPinFail': 'Kan ikke samle inn innholdet. Prøv igjen senere.',
	'contentPinFailOld': 'Kan ikke feste innholdet. Prøv igjen senere.',
	'pinRenameFail': 'Kan ikke endre navnet på den festede ressursen. Prøv igjen senere.',

	// Layouts
	'dropZoneLabel': 'Slipp her for å maksimere',

	//Share
	'shareDefaultPageTitle': 'Side %{index}',

	'nextPage': 'Neste side',
	'previousPage': 'Forrige side',

	'assetAssembly': 'vivisning',

	'toolbar_save': 'Lagre',
	'brgr_saveAs': 'Lagre som',
	'brgr_refresh': 'Oppdater',

	// Save
	'saving': 'Lagrer...',
	'save_success': 'Visningen er lagret.',
	'save_failure': 'Beklager. Visningen kunne ikke lagres. Prøv igjen senere.',
	'dashboard_save_success': 'Dashbordet er lagret.',

	'geminiLeave': 'Du er i ferd med å forlate IBM Watson Analytics.',

	'warning': 'Advarsel',
	'missingDataSetData': 'Dataene for dette datasettet er ikke tilgjengelige. Oppdater datasettet eller kontakt administratoren for å få tilgang til kilden.',

	// Calculations
	'error_calculation_in_use': 'Den valgte beregningen er i bruk og kan ikke slettes.',

	'resize': 'Endre størrelse',
	'rotate': 'Roter',
	'moveHandle': 'Flytt widget',
	'expandHandle': 'Utvid',
	'panHandle': 'Panorer',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Naviger til',

	// Slide out titles
	'shapeSlideoutTitle': 'Former',
	'textSlideoutTitle': 'Tekst',
	'mediaSlideoutTitle': 'Media',
	'visualizationSlideoutTitle': 'Visualiseringer',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Oppgitt JSON er ugyldig. Du finner mer informasjon i feilloggen.',

	// Widget type labels
	'shape_label': 'Form',
	'image_label': 'Bilde',
	'data_label': 'Diagram',
	'media_label': 'Media',
	'text_label': 'Tekst',
	'embedMedia_label': 'Media',
	'youtube_label': 'YouTube-video',
	'webpage_label': 'Webside',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Form',
	'noExtraText_shape_numbered': 'Form (%{number})',
	'few_shape': 'Gruppe med %{count} former',
	'many_shape': 'Gruppe med %{count} former',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text}-bilde',
	'one_image_numbered': '%{text}-bilde (%{number})',
	'noExtraText_image': 'Bilde',
	'noExtraText_image_numbered': 'Bilde (%{number})',
	'few_image': 'Gruppe med %{count} bilder',
	'many_image': 'Gruppe med %{count} bilder',
	'noExtraText_text': 'Tomt tekstfelt',
	'noExtraText_text_numbered': 'Tomt tekstfelt (%{number})',
	'few_text': 'Gruppe med %{count} tekstfelt',
	'many_text': 'Gruppe med %{count} tekstfelt',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube Viewer',
	'pacubeviewer_named': '%{name} Cube Viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': 'Krysstabell med %{values} etter %{row_level1} og %{column_level1}',
	'crosstab_opt_mapping_numbered': 'Krysstabell med %{values} etter %{row_level1} og %{column_level1} (%{number})',
	'crosstab_has_mapping': 'Krysstabell med %{values} etter %{row_level1}',
	'crosstab_has_mapping_numbered': 'Krysstabell med %{values} etter %{row_level1} (%{number})',
	'crosstab_no_mapping': 'Tom krysstabell',
	'crosstab_no_mapping_numbered': 'Tom krysstabell (%{number})',
	'crosstab_named': 'Krysstabellen %{name}',
	'crosstab_named_numbered': 'Krysstabellen %{name} (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols}-tabell',
	'JQGrid_has_mapping_numbered': '%{grid_cols}-tabell (%{number})',
	'JQGrid_no_mapping': 'Tom tabell',
	'JQGrid_no_mapping_numbered': 'Tom Tøm (%{number})',
	'JQGrid_named': '%{name}-tabell',
	'JQGrid_named_numbered': '%{name}-tabell (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1}-hierarki',
	'hierarchy_has_mapping_numbered': '%{level1}-hierarki (%{number})',
	'hierarchy_no_mapping': 'Tomt hierarki',
	'hierarchy_no_mapping_numbered': 'Tomt hierarki (%{number})',
	'hierarchy_named': '%{name}-hierarki',
	'hierarchy_named_numbered': '%{name}-hierarki (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories}-kart',
	'map_has_mapping_numbered': '%{categories}-kart (%{number})',
	'map_no_mapping': 'Tomt kart',
	'map_no_mapping_numbered': 'Tomt kart (%{number})',
	'map_named': '%{name}-kart',
	'map_named_numbered': '%{name}-kart (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': 'Sammendragsverdien %{actual}',
	'summary_has_mapping_numbered': 'Sammendragsverdien %{actual} (%{number})',
	'summary_no_mapping': 'Tom sammendragsverdi',
	'summary_no_mapping_numbered': 'Tom sammendragsverdi (%{number})',
	'summary_named': 'Sammendragsverdien %{name}',
	'summary_named_numbered': 'Sammendragsverdien %{name} (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} med %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual} med %{sparkline.time} KPI (%{number})',
	'kpi_has_mapping': 'KPI %{actual}',
	'kpi_has_mapping_numbered': 'KPI %{actual} (%{number})',
	'kpi_no_mapping': 'Tom KPI',
	'kpi_no_mapping_numbered': 'Tom KPI (%{number})',
	'kpi_named': 'KPI %{name}',
	'kpi_named_numbered': 'KPI %{name} (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': 'Infografikk med %{actual}',
	'infographicSummary_has_mapping_numbered': 'Infografikk med %{actual} (%{number})',
	'infographicSummary_no_mapping': 'Tom infografikk',
	'infographicSummary_no_mapping_numbered': 'Tom infografikk (%{number})',
	'infographicSummary_named': 'Infografikk med %{name}',
	'infographicSummary_named_numbered': 'Infografikk med %{name} (%{number})',
	'noExtraText_youtube': 'YouTube-video',
	'noExtraText_youtube_numbered': 'YouTube-video (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': 'YouTube-videoen %{text}',
	'one_youtube_numbered': 'YouTube-videoen %{text} (%{number})',
	'few_youtube': 'Gruppe med %{count} YouTube-videoer',
	'many_youtube': 'Gruppe med %{count} YouTube-videoer',
	'noExtraText_embedMedia': 'Medielink',
	'noExtraText_embedMedia_numbered': 'Medielink (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': 'Medielinken %{text}',
	'one_embedMedia_numbered': 'Medielinken %{text} (%{number})',
	'few_embedMedia': 'Gruppe med %{count} medielinker',
	'many_embedMedia': 'Gruppe med %{count} medielinker',
	'noExtraText_media': 'Media',
	'noExtraText_media_numbered': 'Media (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': 'Mediet %{text}',
	'one_media_numbered': 'Mediet %{text} (%{number})',
	'few_media': 'Gruppe med %{count} medier',
	'many_media': 'Gruppe med %{count} medier',
	'noExtraText_webpage': 'Webside',
	'noExtraText_webpage_numbered': 'Webside (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': 'Websiden %{text}',
	'one_webpage_numbered': 'Websiden %{text} (%{number})',
	'few_webpage': 'Gruppe med %{count} websider',
	'many_webpage': 'Gruppe med %{count} websider',
	'one_unknown': 'Et objekt',
	'one_unknown_numbered': 'Et objekt (%{number})',
	'few_unknown': 'Gruppe med %{count} objekter',
	'many_unknown': 'Gruppe med %{count} objekter',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Neste',
	'previous': 'Forrige',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Gjeldende navigeringsgruppe er %{navigation_group_name}',

	//Page Context
	'filterBlank': '(tom)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Filterverdier kan ikke lastes inn',
	'editTimelineHighlight': 'Rediger utheving',

	'filterDockChevronLeft': 'Bla gjennom dataene',
	'filterDockChevronRight': 'Bla gjennom dataene',
	'expand': 'Utvid',
	'collapse': 'Komprimer',

	//Reset Dashboard
	'dashboardResetTitle': 'Tilbakestill dashbord',
	'dashboardResetMessage': 'Er du sikker på at du vil tilbakestille alle endringene som er tatt i bruk på dette dashbordet?',
	'dashboardResetToast': 'Dashbordet er tilbakestilt.',

	//Generate PDF
	'buildingPDF': 'Bygger PDF...',
	'exportPDF': 'Eksporter til PDF',
	'pageSize': 'Sidestørrelse',
	'orientation': 'Retning',
	'filtersPresentPDF': 'Filter(e) som er brukt på visualiseringen(e) på forrige side:',
	'errorPDF': 'Kan ikke generere PDF. Oppdater og prøv igjen.',
	'errorPrintPDF': 'Kan ikke generere PDF. Prøv på nytt.',
	'printPDFInfo': 'Vis dokumentasjon',
	'pdfWidget': 'Widget',
	'includeFilters': 'Vis filterdetaljer',
	'portrait': 'Stående',
	'landscape': 'Liggende',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Dashbordet er oppgradert. Lagre nå for å opprettholde optimal ytelse.',

	'migratingDashboard': 'Dashborddataene dine må migreres. Dashbordet vil bli lagret når migreringen er ferdig...',
	'migrateDone': 'Dashborddataene dine er migrert.',
	'migrateNoPermission': 'Dashborddataene dine må migreres, og dette krever skrivetillatelse. Visualiseringer vil bli gjengitt med feil.',
	'migratingDataSourcesFailed': 'datamigrering mislyktes for en eller flere datakilder',

	'ariaFullScreenMessage': 'Trykk på Escape for å avslutte full skjerm',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': 'Boblediagram med %{categories} og pakket hierarki',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': 'Boblediagram med %{categories} og pakket hierarki (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Tomt pakket hierarkiboblediagram',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Tomt pakket hierarkiboblediagram (%{number})',
	'LIVE_hierarchy_packed_bubble_named': 'Boblediagram med %{name} og pakket hierarki',
	'LIVE_hierarchy_packed_bubble_named_numbered': 'Boblediagram med %{name} og pakket hierarki (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': 'Marimekko-diagram med %{categories} etter %{values}',
	'LIVE_marimekko_has_mapping_numbered': 'Marimekko-diagram med %{categories} etter %{values} (%{number})',
	'LIVE_marimekko_no_mapping': 'Tomt Marimekko-diagram',
	'LIVE_marimekko_no_mapping_numbered': 'Tomt Marimekko-diagram (%{number})',
	'LIVE_marimekko_named': 'Marimekko-diagrammet %{name}',
	'LIVE_marimekko_numbered': 'Marimekko-diagrammet %{name} (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': 'Solstrålediagrammet %{values}',
	'LIVE_sunburst_has_mapping_numbered': 'Solstrålediagrammet %{values} (%{number})',
	'LIVE_sunburst_no_mapping': 'Tomt solstrålediagram',
	'LIVE_sunburst_no_mapping_numbered': 'Tomt solstrålediagram (%{number})',
	'LIVE_sunburst_named': 'Solstrålediagrammet %{name}',
	'LIVE_sunburst_named_numbered': 'Solstrålediagrammet %{name} (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': 'Driveranalysediagrammet %{values}',
	'LIVE_decision_analysis_has_mapping_numbered': 'Driveranalysediagrammet %{values} (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Tomt driveranalysediagram',
	'LIVE_decision_analysis_no_mapping_numbered': 'Tomt driveranalysediagram (%{number})',
	'LIVE_decision_analysis_named': 'Driveranalysediagrammet %{name}',
	'LIVE_decision_analysis_named_numbered': 'Driveranalysediagrammet %{name} (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': 'Linje- og kolonnediagram med %{categories} etter %{columnValue} og %{lineValue}',
	'LIVE_line_column_opt_mapping_numbered': 'Linje- og kolonnediagram med %{categories} etter %{columnValue} og %{lineValue} (%{number})',
	'LIVE_line_column_has_mapping': 'Linje- og kolonnediagram med %{columnValue} og %{lineValue}',
	'LIVE_line_column_has_mapping_numbered': 'Linje- og kolonnediagram med %{categories} etter %{columnValue} og %{lineValue} (%{number})',
	'LIVE_line_column_no_mapping': 'Tomt linje- og kolonnediagram',
	'LIVE_line_column_no_mapping_numbered': 'Tomt linje- og kolonnediagram (%{number})',
	'LIVE_line_column_named': 'Linje- og kolonnediagrammet %{name}',
	'LIVE_line_column_named_numbered' : 'Linje- og kolonnediagrammet %{name} (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': 'Boblediagram med %{x} etter %{y} og %{size}',
	'LIVE_bubble_chart_has_mapping_numbered': 'Boblediagram med %{x} etter %{y} og %{size} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Tomt boblediagram',
	'LIVE_bubble_chart_no_mapping_numbered': 'Tomt boblediagram (%{number})',
	'LIVE_bubble_chart_named': 'Boblediagrammet %{name}',
	'LIVE_bubble_chart_named_numbered': 'Boblediagrammet %{name} (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': 'Punktdiagrammet %{actual}',
	'LIVE_bullet_has_mapping_numbered': 'Punktdiagrammet %{actual} (%{number})',
	'LIVE_bullet_no_mapping': 'Tomt punktdiagram',
	'LIVE_bullet_no_mapping_numbered': 'Tomt punktdiagram (%{number})',
	'LIVE_bullet_named': 'Punktdiagrammet %{name}',
	'LIVE_bullet_named_numbered': 'Punktdiagrammet %{name} (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Data på dette dashbordet leveres av',
	'showFooterToggleButtonText': 'Vis bunntekst',
	'showFooterSectionText': 'Bunntekst'

});
